module.exports = __webpack_public_path__ + "assets/img/video44.29af1bcc.png";